<template>
  <div class="result_area_viewPage">
    <div class="result_centent_viewPage">
     <div :class="'result_viewPage '+ 'success'+'_viewPage'">
        <Icon type="md-checkmark" size="70" color="#ffffff" />
      </div>
      <div class="title_viewPage">
        提交成功
      </div>
      <div class="desc_viewPage">
        您的申请已提交，流水号为：{{result}}
      </div>
      <div class="actions_viewPage">
        <Button type="primary" @click="backList">返回列表</Button>
      </div>
    </div>

    <!-- <template #desc>
      您的申请已提交，流水号为：{{result.desc}}
    </template> -->
    <!-- <template #actions>
      <Button type="primary" @click="backList">返回列表</Button>
    </template> -->
  </div>
</template>
<script>
export default {
  props: { result: Object },

  methods: {
    backList() {
      this.$router.push({ path: '/myOtherApplications' })
    },
  },
}
</script>